import { Injectable, InjectionToken } from '@angular/core';
import get from 'lodash-es/get';
import { SessionStorage } from '@finder/shared/services/session-storage/session-storage.service';
import { HttpClient } from '@angular/common/http';
import { CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';

export const ConfigServiceToken = new InjectionToken('config.service');
export const STAGE_CDN = 'https://stage.cdn1.parksmedia.wdprapps.disney.com';

@Injectable()
export class ConfigService {
    config: Object;
    constructor(
        private sessionStorage: SessionStorage,
        private http: HttpClient,
    ) {}

    load() {
        return new Promise((resolve, reject) => {
            try {
                const angularConfigValue = this.sessionStorage.get('finderAngularConfig');
                const finderAngularConfig = JSON.parse(angularConfigValue);
                this.config = finderAngularConfig;
                resolve(finderAngularConfig);
            } catch (err) {
                reject(err);
            }
        });
    }

    getValue(key: string) {
        // Get value of config key:
        return get(this.config, key);
    }

    getGeneralConfig() {
        return this.http.get(`/advanced-finder/config/general.json`);
    }

    getCdnUrl() {
        // Check the env values first
        let [ cdnDomain ] = this.getValue(CONFIG_CONSTANTS.cdnListKey);
        // It will be blank if we're in local dev. Revert to fallback
        if (!cdnDomain) {
            cdnDomain = STAGE_CDN;
        }

        return cdnDomain;
    }
}
